import apiUrls from '../urls';

export default function (api) {
    return {
        getDocs() {
            return api.get(apiUrls.DOCUMENTS);
        },
    }
};